<template>
  <div class="app-view-mnp-data">
    <slot name="txtBefore"></slot>
    <div class="mnp-data">
      <b-row class="mnp-type">
        <b-col class="label">
          <slot name="lblType">Rufnummernmitnahme:</slot>
        </b-col>
        <b-col class="value">
          <slot :name="`portingType${mnpData.portingType}`">{{mnpData.portingType}}</slot>
        </b-col>
      </b-row>
      <b-row class="mnp-msisdn">
        <b-col class="label">
          <slot name="lblMsisdn">Zu portierende Rufnummer:</slot>
        </b-col>
        <b-col class="value">{{mnpData.msisdn}}</b-col>
      </b-row>
      <b-row class="mnp-provider">
        <b-col class="label">
          <slot name="lblProvider">Name des Anbieters:</slot>
        </b-col>
        <b-col class="value">{{mnpData.provider.networkKey}}</b-col>
      </b-row>
    </div>
  </div>
</template>
<script>

export default {
  name: 'ShowMnpData',
  props: {
    mnpData: {
      type: Object
    }
  }
}
</script>
